import React from "react";

import process7 from "../assets/images/projects/process7.png";
import small1 from "../assets/images/projects/process-small1.png";
import { fontsName } from "../assets/fonts/fontsName";
import { Link } from "gatsby";

const Councils = ({ littleBenefactorList, schoolCouncil, studentsCouncil }) => {
  return (
    <section className="process-area ptb-100 bg-fafafb">
      <div className="container">
        <div className="section-title">
          {/* <span className="sub-title">
                        <img src={starIcon} alt="banner" /> 
                        How It's Work
                    </span> */}
          <h2 style={{ fontFamily: fontsName.VazirBold }}>
            انجمن های مدرسه
          </h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p> */}
        </div>

        <div className="row align-items-center m-0">
          <div className="col-lg-6 col-md-12 p-0">
            <div className="process-image">
              <img src={process7} alt="banner" />
            </div>
          </div>

          <div className="col-lg-6 col-md-12 p-0">
            <div className="process-content">
              <div className="row">
                {studentsCouncil && studentsCouncil.length > 0 ? (
                  <div className="col-lg-12 col-md-6">
                    <Link to="site/students-council/">
                      <div className="single-box-item">
                        <div className="d-flex align-items-center">
                          <div className="image">
                            <img src={small1} alt="banner" />
                          </div>
                          <h3 style={{ fontFamily: fontsName.VazirBold }}>
                            شورای دانش آموزی
                          </h3>
                          <div className="number">1</div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                {schoolCouncil && schoolCouncil.length > 0 ? (
                  <div className="col-lg-12 col-md-6">
                    <Link to="site/school-council">
                      <div className="single-box-item">
                        <div className="d-flex align-items-center">
                          <div className="image">
                            <img src={small1} alt="banner" />
                          </div>
                          <h3 style={{ fontFamily: fontsName.VazirBold }}>
                            انجمن اولیا و مربیان
                          </h3>
                          <div className="number">2</div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                {littleBenefactorList && littleBenefactorList.length > 0 ? (
                  <div className="col-lg-12 col-md-6">
                    <Link to="site/little-benefactors">
                      <div className="single-box-item">
                        <div className="d-flex align-items-center">
                          <div className="image">
                            <img src={small1} alt="banner" />
                          </div>
                          <h3 style={{ fontFamily: fontsName.VazirBold }}>
                            خیرین کوچک
                          </h3>
                          <div className="number">3</div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  ""
                )}

                {/* <div className="col-lg-12 col-md-6">
                                    <div className="single-box-item">
                                        <div className="d-flex align-items-center">
                                            <div className="image">
                                                <img src={small4} alt="banner" />
                                            </div>
                                            <h3>Explore the Data</h3>
                                            <div className="number">4</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className="single-box-item">
                                        <div className="d-flex align-items-center">
                                            <div className="image">
                                                <img src={small5} alt="banner" />
                                            </div>
                                            <h3>Perform Analysis</h3>
                                            <div className="number">5</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className="single-box-item">
                                        <div className="d-flex align-items-center">
                                            <div className="image">
                                                <img src={small6} alt="banner" />
                                            </div>
                                            <h3>Communicate Results</h3>
                                            <div className="number">6</div>
                                        </div>
                                    </div>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Councils;
